import {
  NewsletterConfirmationFields,
  NewsletterConfirmationProps,
} from "../types/NewsletterConfirmation.types"
import { StringField } from "../../../types/types"

export class NewsletterConfirmationModel {
  private readonly fields: null | NewsletterConfirmationFields
  constructor(props: NewsletterConfirmationProps) {
    this.fields = props.fields || null
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }
  get description(): StringField | undefined {
    return this.fields?.Description
  }
}
